import React from 'react';
import { Link } from 'react-router-dom';
import './ServerConfig.css';

const ServerConfig = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const configTypes = [
    {
      icon: '⚙️',
      title: 'کانفیگ سرور cPanel',
      desc: 'نصب و راه‌اندازی کامل cPanel با بهینه‌سازی امنیت و عملکرد. مناسب برای هاستینگ‌های حرفه‌ای و ارائه‌دهندگان خدمات میزبانی وب.',
      features: ['نصب cPanel', 'تنظیمات امنیتی', 'بهینه‌سازی عملکرد', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/cpanel',
      color: '#06B6D4',
    },
    {
      icon: '🔧',
      title: 'کانفیگ سرور DirectAdmin',
      desc: 'نصب و راه‌اندازی DirectAdmin با تنظیمات بهینه و امن. کنترل پنلی سبک، سریع و کم‌مصرف برای هاستینگ‌های کوچک و بزرگ.',
      features: ['نصب DirectAdmin', 'تنظیمات امنیتی', 'بهینه‌سازی عملکرد', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/directadmin',
      color: '#EC4899',
    },
    {
      icon: '🌐',
      title: 'کانفیگ سرور Plesk',
      desc: 'نصب و راه‌اندازی Plesk روی سرورهای ویندوز و لینوکس. کنترل پنل مدرن و قدرتمند با پشتیبانی از ASP.NET و MSSQL.',
      features: ['نصب Plesk', 'تنظیمات امنیتی', 'بهینه‌سازی عملکرد', 'پشتیبانی ویندوز/لینوکس', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/plesk',
      color: '#8B5CF6',
    },
    {
      icon: '🖥️',
      title: 'کانفیگ سرور Virtualizor',
      desc: 'نصب و راه‌اندازی Virtualizor برای مدیریت VPS و مجازی‌سازی. مناسب برای ارائه‌دهندگان هاست و VPS با کنترل کامل بر روی ماشین‌های مجازی.',
      features: ['نصب Virtualizor', 'تنظیمات شبکه', 'مدیریت ماشین‌ها', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/virtualizor',
      color: '#F59E0B',
    },
    {
      icon: '🏢',
      title: 'کانفیگ سرور ESXi',
      desc: 'نصب و راه‌اندازی VMware ESXi برای مجازی‌سازی حرفه‌ای در سطح سازمانی. مناسب برای دیتاسنترها و شرکت‌های بزرگ.',
      features: ['نصب ESXi', 'تنظیمات شبکه', 'مدیریت ماشین‌ها', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/esxi',
      color: '#F97316',
    },
    {
      icon: '🐳',
      title: 'کانفیگ Docker',
      desc: 'نصب و راه‌اندازی Docker و Docker Compose برای اپلیکیشن‌های کانتینری. مناسب برای توسعه‌دهندگان و تیم‌های فنی.',
      features: ['نصب Docker', 'تنظیمات شبکه', 'مدیریت کانتینرها', 'پشتیبانی ۲۴/۷'],
      link: '/server-config/docker',
      color: '#22C55E',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>کانفیگ سرور | cPanel، DirectAdmin، Plesk، Virtualizor، ESXi و Docker | افرسل</h1>
        <p>خدمات حرفه‌ای کانفیگ سرور با بهترین کیفیت و پشتیبانی ۲۴ ساعته. نصب و راه‌اندازی تمام کنترل پنل‌ها و سیستم‌های مجازی‌سازی.</p>
        <meta name="description" content="کانفیگ سرور با بهترین کیفیت از افرسل. خدمات کانفیگ cPanel، DirectAdmin، Plesk، Virtualizor، ESXi و Docker با پشتیبانی ۲۴/۷." />
      </div>

      <section className="config-main-hero">
        <div className="config-main-hero-bg"></div>
        <div className="wrap">
          <div className="config-main-hero-content">
            <div className="config-main-badge">
              <span className="pulse-dot"></span>
              🔧 کانفیگ حرفه‌ای سرور
            </div>
            <h1 className="config-main-hero-title">
              کانفیگ <em>سرور</em> با بهترین کیفیت
            </h1>
            <p className="config-main-hero-desc">
              خدمات حرفه‌ای نصب و راه‌اندازی انواع سرور با بهترین کیفیت و پشتیبانی ۲۴ ساعته. 
              از cPanel و DirectAdmin تا Plesk، Virtualizor، ESXi و Docker، همه را با بهترین تنظیمات انجام می‌دهیم.
            </p>
            <div className="config-main-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۶+</span>
                <span className="stat-label">سرویس</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="config-types">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">خدمات کانفیگ</span>
            <h2 className="sec-h">کانفیگ <em>حرفه‌ای</em> سرور</h2>
            <p className="sec-p">خدمات نصب و راه‌اندازی انواع سرور با بهترین کیفیت و تنظیمات امنیتی.</p>
          </div>
          <div className="config-types-grid">
            {configTypes.map((type, i) => (
              <Link to={type.link} key={i} className="config-type-card">
                <span className="config-type-icon">{type.icon}</span>
                <h3 className="config-type-title">{type.title}</h3>
                <p className="config-type-desc">{type.desc}</p>
                <ul className="config-type-features">
                  {type.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="config-type-link" style={{ color: type.color }}>
                  درخواست کانفیگ ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="config-main-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              کانفیگ <em>حرفه‌ای</em> سرور خود را به ما بسپارید
            </h2>
            <p className="cta-desc">
              با تیم ما تماس بگیرید تا بهترین کانفیگ را برای سرور شما انجام دهیم. 
              نصب و راه‌اندازی حرفه‌ای با بهترین تنظیمات امنیتی و عملکردی.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>درخواست کانفیگ</button>
              <button className="btn-lg ghost" onClick={() => {
                const el = document.querySelector('.config-types-grid');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                مشاهده خدمات
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServerConfig;
